import { useRef, useEffect } from 'react'
import { BREAKPOINT_SIZES } from '@consts/index'
import { objectKeys } from '@helpers/utils'
import useWindowSize from './useWindowSize'

export { useWindowSize }
export { default as useExiting } from './useExiting'
export { default as useIdle } from './useIdle'
export { default as useMediaQuery } from './useMediaQuery'

export function useViewportDimensions() {
  const windowSize = useWindowSize()
  const breakpoint = objectKeys(BREAKPOINT_SIZES).find(
    key => (windowSize.width || 0) < BREAKPOINT_SIZES[key]
  )
  return { breakpoint }
}

export function useInterval(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>(() => undefined)
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])
  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

export function usePrevious<T>(value: T) {
  const ref = useRef<T>(value)
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
